import messagesJson from "./messages.json";

export const initialState = { messages: messagesJson };
